import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=ce8b696a"
import script from "./Book.vue?vue&type=script&lang=js"
export * from "./Book.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Link: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/link/Link.vue').default,ErrorSummary: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/error-summary/ErrorSummary.vue').default,FormBooking: require('/home/runner/work/platform/platform/packages/client/src/components/forms/booking/FormBooking.vue').default,Basket: require('/home/runner/work/platform/platform/packages/client/src/components/elements/book/basket/Basket.vue').default})
